// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"70f27648","118":"f1af2bd0","303":"f5a9c0f4","382":"58fb207a","387":"dfdffe13","393":"50e5a5cf","397":"27d6decd","426":"60d59ad0","433":"1ccd874d","512":"ee14e86c","781":"34b1ca71","825":"f190c784","847":"80cd8ca6"}[chunkId] + ".chunk.js";
};